
export default {
	props: {
		color: {
			type: String,
			default: '#fff',
		},
		scale: {
			type: String,
			default: '1',
		},
		size: {
			type: String,
			default: undefined,
		},
	},
	computed: {
		ballSize() {
			return this.size || '15px'
		},
	},
}
